import React from 'react';
import CountUp from 'react-countup';
import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer';

const Future = () => {
    const textVariants = {
        hidden: { opacity: 0, x: -10 },
        visible: (i) => ({
            opacity: 1,
            x: 0,
            transition: { delay: i * 0.05, duration: 0.3, ease: "easeOut" },
        }),
    };
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.2,
    });
    const text = "Unlocking the Future of Real Estate Ownership";
    const characters = text.split("");

    return (
        <section className="section-benefits" ref={ref}>
            <div className="tf-container pb-4">
                <div className="row">
                    <div className="col-12">
                        <div className="box-benefits d-flex align-items-center">
                            <h2 className="title text-start balance">
                                {characters.map((char, i) => (
                                    <motion.span
                                        key={i}
                                        className="inline-block"
                                        variants={textVariants}
                                        initial="hidden"
                                        animate={inView ? "visible" : "hidden"}
                                        custom={i}
                                    >
                                        {char}
                                    </motion.span>
                                ))}
                            </h2>
                            <div className="content">
                                <div className="description animate__fadeInUp animate__animated" data-wow-duration="1s" data-wow-delay="0s">
                                    <p className="text-1">
                                        Did you know that fractional ownership can increase your investment potential by up to 30%? Join a growing market that is reshaping property investment.
                                    </p>
                                </div>
                                <div className="d-flex gap-5">
                                    <div className=" d-flex flex-column gap-5  ">
                                        <span className=' countup-text-size text-dark'>
                                            {inView && <CountUp start={0} end={70} duration={2} suffix="%" />}
                                        </span>
                                        <span className="text-1 fw-6">
                                            of investors prefer fractional ownership for flexibility.
                                        </span>
                                    </div>

                                    <div className="d-flex gap-5 flex-column">
                                        <span className='countup-text-size text-dark'>
                                            {inView && <CountUp start={0} end={65} duration={2} suffix="%" />}
                                        </span>
                                        <span className="text-1 fw-6">
                                            of properties appreciate faster with shared ownership models.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Future;
